import React from 'react';
import { BudgetRecipientEnum } from '../../../createAndEdit/types';
import { Budget, BudgetHistory } from '../../../types';
import { formatRecipientLabel } from '../../../utils';
import StatusBadge from '../StatusBadge';
import ViewBudgetButton from '../ViewBudgetButton';
import BudgetHistorySection from './BudgetHistorySection';
import { useBudgetNavigation } from '../../hooks/useBudgetNavigation';

interface IBudgetRowProps {
  budget: Budget;
  isExpanded: boolean;
  hasHistory: boolean;
  history: BudgetHistory[];
  isLoading: boolean;
  onToggleRow: (budgetId: string) => void;
  onViewBudget: (budgetId: string, versionNumber?: number) => void;
  onEditBudget?: (budgetId: string, versionNumber?: number) => void;
  userProfile?: BudgetRecipientEnum | string;
}

const BudgetRow = (props: IBudgetRowProps) => {
  const { handleBudgetClick } = useBudgetNavigation({
    budget: props.budget,
    userProfile: props.userProfile,
    onViewBudget: props.onViewBudget,
    onEditBudget: props.onEditBudget,
  });

  return (
    <React.Fragment>
      <tr>
        <td>{props.budget.consultantName}</td>
        <td>{props.budget.originUserName ?? 'Não identificado'} ({formatRecipientLabel(props.budget.origin)})</td>
        <td>{formatRecipientLabel(props.budget.recipient)}</td>
        <td>{props.budget.user}</td>
        <td>
          <ViewBudgetButton onClick={handleBudgetClick} />
        </td>
        <td>{props.budget.version}</td>
        <td>{props.budget.date}</td>
        <td>
          <StatusBadge status={props.budget.status} />
        </td>
        <td onClick={(e) => e.stopPropagation()}>
          {props.hasHistory && (
            <button
              type="button"
              className={`rioglyph ${
                props.isExpanded ? 'rioglyph-chevron-up' : 'rioglyph-chevron-down'
              } cursor-pointer border-0 bg-transparent p-0`}
              onClick={() => props.onToggleRow(props.budget.id)}
              aria-label={props.isExpanded ? 'Recolher histórico' : 'Expandir histórico'}
              aria-expanded={props.isExpanded}
            ></button>
          )}
        </td>
      </tr>
      {props.isExpanded && props.hasHistory && (
        <tr>
          <td colSpan={9} className="p-0">
            <BudgetHistorySection
              history={props.history}
              isLoading={props.isLoading}
              budgetId={props.budget.id}
              onViewBudget={props.onViewBudget}
              onEditBudget={props.onEditBudget}
              budget={props.budget}
              userProfile={props.userProfile}
            />
          </td>
        </tr>
      )}
    </React.Fragment>
  );
};

export default BudgetRow;

